import React from 'react'

const NonConformityReport = () => {
    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card" id={1}>
                    <div className="card-body">
                        <div className="checklist-title-bx">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="text-center">
                                        <h4>NON CONFORMITY REPORT </h4>
                                        <p>
                                            Following to be checked and confirmed before official delivery
                                            of the vessel
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 ">
                                <div className="report-index-top">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="hd-s2">
                                                    <p>Yard</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <div className="hull-select-box">
                                                        <select className="form-select">
                                                            <option>Select Yard Number</option>
                                                            <option>CL-001</option>
                                                            <option>CL-002</option>
                                                            <option>CL-003</option>
                                                            <option>CL-004</option>
                                                        </select>
                                                    </div>
                                                </td>
                                                <td className="hd-s2 pl10">
                                                    <p>Hull No</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <div className="hull-select-box">
                                                        <select className="form-select">
                                                            <option>Select Hull Number</option>
                                                            <option>CL-001</option>
                                                            <option>CL-002</option>
                                                            <option>CL-003</option>
                                                            <option>CL-004</option>
                                                        </select>
                                                    </div>
                                                </td>
                                                <td className="hd-s2 pl10">
                                                    <p>Owner</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Owner Name"
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="hd-s2">
                                                    <p>Date</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Date"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="hd-s2 pl10 w150">
                                                    <p>Sent To</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="(Yard Project manager and CC to OSS)"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="hd-s2 pl10">
                                                    <p>Please reply by</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="(Mention a date within 5 days of issuing NCR)"
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="hd-s2">
                                                    <p>Issued By </p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="(Designation and Name)"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="hd-s2 pl10">
                                                    <p>OSS reference No</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="(NCR/ Hull No/ NNNN)"
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="hd-s2 pl10">
                                                    <p>Subject</p>
                                                </td>
                                                <td className="td-input-bx">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="(Give brief description)"
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="note-info">
                                    <p>
                                        Enter date of issue/ Reference No/ Suject as above in NCR Index
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 ">
                                <div className="appraisal-report-table-responsive">
                                    <table className="assessment-table" cellSpacing={0}>
                                        <tbody>
                                            <tr className="tr-info">
                                                <td colSpan={2} className="">
                                                    <p className="text-left">
                                                        <b>NNNN : </b>Serial Number starting from 0001
                                                    </p>
                                                </td>
                                                <td colSpan={1} className="">
                                                    <p className="text-right">
                                                        Fill in <b>NA</b> if any field is not applicable
                                                    </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="hd-s2 pd10">
                                                    {" "}
                                                    <p>S.No.</p>
                                                </td>
                                                <td className="hd-s2 pd10 w300">
                                                    <p>Enquiry Reference</p>
                                                </td>
                                                <td className="hd-s1 pd10">
                                                    <p />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">1.</p>
                                                </td>
                                                <td className="tb-input-value pl10">
                                                    <p>Contract Clause</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">2.</p>
                                                </td>
                                                <td className="tb-input-value pl10">
                                                    <p>Specification reference</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">3.</p>
                                                </td>
                                                <td className="tb-input-value pl10">
                                                    <p>Drawing No</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">4.</p>
                                                </td>
                                                <td className="tb-input-value pl10">
                                                    <p>Classification Standards reference</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">4.</p>
                                                </td>
                                                <td className="tb-input-value pl10">
                                                    <p>WPS reference</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">5.</p>
                                                </td>
                                                <td className="tb-input-value pl10">
                                                    <p>Material Change</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">6.</p>
                                                </td>
                                                <td className="tb-input-value pl10">
                                                    <p>Equipment List</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">7.</p>
                                                </td>
                                                <td className="tb-input-value pl10">
                                                    <p>Site Query Reference</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">8.</p>
                                                </td>
                                                <td className="tb-input-value pl10">
                                                    <p>Inspection Comment Reference</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">9.</p>
                                                </td>
                                                <td className="tb-input-value pl10">
                                                    <p>Approval Comment Reference</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">10.</p>
                                                </td>
                                                <td className="tb-input-value pl10">
                                                    <p>Building Standards Reference</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">11.</p>
                                                </td>
                                                <td className="tb-input-value pl10">
                                                    <p>Meeting Minutes Reference</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">12.</p>
                                                </td>
                                                <td className="tb-input-value pl10">
                                                    <p>Safety Issue</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">13.</p>
                                                </td>
                                                <td className="tb-input-value pl10">
                                                    <p>Other (please specify)</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">14.</p>
                                                </td>
                                                <td className="tb-input-value pl10">
                                                    <p>Location</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">15.</p>
                                                </td>
                                                <td className="tb-input-value pl10">
                                                    <p>Work to be stopped for corrective measure? </p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="(Yes/ NO)"
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr className="tr-info">
                                                <td colSpan={2} className="">
                                                    <p className="text-left" style={{ color: "#0077e2" }}>
                                                        Give reference to one or more as above{" "}
                                                    </p>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <table className="mrt20">
                                                <tbody>
                                                    <tr>
                                                        <td className="hd-b">
                                                            <p>DISCRIPTION</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="input-textarea">
                                                            <textarea defaultValue={""} />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <table className="mrt10">
                                                <tbody>
                                                    <tr>
                                                        <td className="hd-b">
                                                            <p>VERIFIED by Site Team as below</p>
                                                            <p />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={5} className="input-textarea">
                                                            <textarea defaultValue={""} />
                                                        </td>
                                                    </tr>
                                                    <tr className="bottom-sig-tr2-box">
                                                        <td className="input-td">
                                                            <p className="s2">Signature of Site Manager</p>
                                                        </td>
                                                        <td>
                                                            <p className="s1">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder=""
                                                                    defaultValue=""
                                                                />
                                                            </p>
                                                        </td>
                                                        <td className="w50" />
                                                        <td className="input-td">
                                                            <p className="s2">DATE</p>
                                                        </td>
                                                        <td>
                                                            <p className="s1">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder=""
                                                                    defaultValue=""
                                                                />
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="col-lg-6">
                                            <table className="mrt10">
                                                <tbody>
                                                    <tr>
                                                        <td className="hd-b">
                                                            <p>SHIPYARD REPLY</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="input-textarea" colSpan={5}>
                                                            <textarea defaultValue={""} />
                                                        </td>
                                                    </tr>
                                                    <tr className="bottom-sig-tr2-box mrt10">
                                                        <td className="input-td">
                                                            <p className="s2">Signature of Site Manager</p>
                                                        </td>
                                                        <td>
                                                            <p className="s1">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder=""
                                                                    defaultValue=""
                                                                />
                                                            </p>
                                                        </td>
                                                        <td className="w50" />
                                                        <td className="input-td">
                                                            <p className="s2">DATE</p>
                                                        </td>
                                                        <td>
                                                            <p className="s1">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder=""
                                                                    defaultValue=""
                                                                />
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-4"></div>
                                <div className="row mt-4">
                                    <div className="col-lg-12 text-left ">
                                        <a
                                            href="ship-inspection-progress-list.php"
                                            className="btn btn-success"
                                            style={{
                                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                                borderColor: "#2b5a7e"
                                            }}
                                        >
                                            Submit
                                        </a>
                                        <button
                                            type="reset"
                                            className="btn btn-danger ms-3"
                                            style={{
                                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                                borderColor: "#2b5a7e"
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default NonConformityReport